module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-beijing.a6f74312.png";